
import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next";

import {
  Card,
  Col,
  Nav,
  Row,
  Tab,
  Image,
  Modal,
  Button,
  Form,
  Badge,
  Container
} from "react-bootstrap"

import classnames from "classnames"

import small from "../../../assets/images/small/img-2.jpg"
import small2 from "../../../assets/images/small/img-6.jpg"
import small3 from "../../../assets/images/small/img-5.jpg"
import BlogPost from "./blogPost"
import { Heart, MessageCircle, PlayCircle, Send, Share2, Tag, ThumbsUp } from "lucide-react"

const BlogList = () => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState("1");
  const [activeTab1, setActiveTab1] = useState('recent');
  const [posts, setPosts] = useState([
    {
      id: 1,
      title: "Comment avoir une alimentation saine",
      author: "Marie Laurent",
      date: "22 Oct, 2024",
      image: small,
      content: "une alimentation saine et equilibrée ...",
      likes: 45,
      comments: [
        { id: 1, author: "Jean Dupont", text: "Super article !", likes: 5 },
        { id: 2, author: "Sophie Martin", text: "Très instructif !", likes: 3 }
      ],
      tags: ["DIET", "SPORT"],
      hasVideo: true
    },
    {
      id: 2,
      title: "Les meilleures pratiques être en forme",
      author: "Paul Dubois",
      date: "21 Oct, 2024",
      image: small2,
      content: "Découvrez les meilleures pratiques pour rester en forme et en bonne santé...",
      likes: 38,
      comments: [
        { id: 3, author: "Marc Antoine", text: "Excellent point de vue!", likes: 4 }
      ],
      tags: ["ALIMENTATION", "SPORT"],
      hasVideo: false
    },
    {
      id: 3,
      title: "Comment perdre du poids",
      author: "Marie Laurent",
      date: "20 Oct, 2024",
      image: small3,
      content: "Comment perdre du poids de manière saine et efficace...",
      likes: 25,
      comments: [],
      tags: ["DIET", "SPORT"],
      hasVideo: true
    }
  ]);

  const [showCommentModal, setShowCommentModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [newComment, setNewComment] = useState('');

  const handleLike = (postId) => {
    setPosts(posts.map(post => 
      post.id === postId ? { ...post, likes: post.likes + 1 } : post
    ));
  };

  const handleAddComment = () => {
    if (!newComment.trim()) return;
    
    setPosts(posts.map(post => 
      post.id === selectedPost ? {
        ...post,
        comments: [...post.comments, {
          id: post.comments.length + 1,
          author: "Utilisateur",
          text: newComment,
          likes: 0
        }]
      } : post
    ));
    
    setNewComment('');
    setShowCommentModal(false);
  };
  return (
    <>
     <Container className="py-1">
      <Card className="shadow-sm">
        {/* <Card.Header className="bg-white border-0">
          <Nav 
            variant="pills" 
            className="justify-content-center gap-3"
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
          >
            <Nav.Item>
              <Nav.Link eventKey="recent" className="px-4">
                Articles Récents
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="trending" className="px-4">
                Tendances
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Header> */}

        <Card.Body className="p-4">
          {posts.map(post => (
            <BlogPost1 
              key={post.id}
              post={post}
              onLike={handleLike}
              onCommentClick={() => {
                setSelectedPost(post.id);
                setShowCommentModal(true);
              }}
            />
          ))}
        </Card.Body>
      </Card>

      <Modal show={showCommentModal} onHide={() => setShowCommentModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Ajouter un commentaire</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Votre commentaire..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
              />
            </Form.Group>
          </Form>
          <div className="mt-3">
            {selectedPost && posts.find(p => p.id === selectedPost)?.comments.map(comment => (
              <Card key={comment.id} className="mb-2">
                <Card.Body>
                  <div className="d-flex justify-content-between">
                    <strong>{comment.author}</strong>
                    <div className="d-flex align-items-center gap-2">
                      <ThumbsUp size={16} /> {comment.likes}
                    </div>
                  </div>
                  <p className="mb-0 mt-2">{comment.text}</p>
                </Card.Body>
              </Card>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCommentModal(false)}>
            Fermer
          </Button>
          <Button variant="primary" onClick={handleAddComment}>
            Commenter <Send size={16} className="ms-2" />
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>

   
    </>
  )
 
};

const BlogPost1 = ({ post, onLike, onCommentClick }) => {
  const navigate = useNavigate();

  return (
    <Card className="mb-4 border-0 shadow-sm">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 className="mb-1">{post.title}</h4>
            <div className="text-muted">
              Par {post.author} • {post.date}
            </div>
          </div>
          <Share2 className="text-muted cursor-pointer" />
        </div>

        <div className="position-relative mb-3 cursor-pointer" onClick={() => navigate(`/blog-detail/${post.id}`)}>
          <Image src={post.image} className="w-100 rounded" style={{ objectFit: 'cover', height: '400px' }} />
          {post.hasVideo && (
            <div className="position-absolute top-50 start-50 translate-middle">
              <PlayCircle size={48} color="white" className="cursor-pointer" />
            </div>
          )}
        </div>

        <p className="text-muted">{post.content}</p>

        <div className="d-flex gap-2 mb-3">
          {post.tags.map((tag, index) => (
            <Badge key={index} bg="light" text="dark" className="d-flex align-items-center gap-1">
              <Tag size={14} />
              {tag}
            </Badge>
          ))}
        </div>

        <div className="d-flex gap-4">
          <Button 
            variant="light" 
            className="d-flex align-items-center gap-2"
            onClick={() => onLike(post.id)}
          >
            <Heart size={18} className={post.likes > 0 ? 'text-danger' : ''} />
            {post.likes}
          </Button>
          <Button 
            variant="light" 
            className="d-flex align-items-center gap-2"
            onClick={onCommentClick}
          >
            <MessageCircle size={18} />
            {post.comments.length}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

const Pagination = () => (
  <div className="text-center">
    {/* Pagination content */}
  </div>
)

const ArchiveContent = () => (
  <Row className="justify-content-center">
    <Col xl={8}>
      <h5>Archive</h5>
      {/* Archive content */}
    </Col>
  </Row>
)
export default BlogList;